import { render } from "./MngUser.vue?vue&type=template&id=84480978&scoped=true&ts=true"
import script from "./MngUser.vue?vue&type=script&lang=ts"
export * from "./MngUser.vue?vue&type=script&lang=ts"

import "./MngUser.vue?vue&type=style&index=0&id=84480978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84480978"]])

export default __exports__